import { DateTimeModel } from "../DateTimeModel";

export class ChildrenModel {
  name: string;
  birthday: string;
  birthdayComponent:DateTimeModel;
}
